import type { Resolver } from "./types";

export const DEFAULT_RESOLVERS: Resolver[] = [
  {
    id: "cloudflare",
    name: "Cloudflare",
    endpoint: "https://cloudflare-dns.com/dns-query",
    preferredMethod: "GET",
    enabled: true
  },
  {
    id: "google",
    name: "Google Public DNS",
    endpoint: "https://dns.google/resolve",
    preferredMethod: "GET",
    enabled: true
  },
  {
    id: "quad9",
    name: "Quad9",
    endpoint: "https://dns.quad9.net/dns-query",
    preferredMethod: "GET",
    enabled: false,
    notes:
      "Present for comparison, but disabled by default because browser-origin tests were CORS blocked."
  },
  {
    id: "opendns",
    name: "OpenDNS",
    endpoint: "https://doh.opendns.com/dns-query",
    preferredMethod: "POST",
    enabled: false,
    notes:
      "Cisco OpenDNS resolver from the screenshot. Disabled by default because browser-origin tests were CORS blocked."
  },
  {
    id: "adguard",
    name: "AdGuard DNS",
    endpoint: "https://dns.adguard-dns.com/dns-query",
    preferredMethod: "POST",
    enabled: false,
    notes:
      "Default AdGuard DNS endpoint from the screenshot. Disabled by default because browser-origin tests were CORS blocked."
  },
  {
    id: "cleanbrowsing",
    name: "CleanBrowsing",
    endpoint: "https://doh.cleanbrowsing.org/doh/security-filter/",
    preferredMethod: "POST",
    enabled: false,
    notes:
      "Security Filter endpoint matching the screenshot. Disabled by default because browser-origin tests were CORS blocked."
  },
  {
    id: "nextdns",
    name: "NextDNS",
    endpoint: "https://dns.nextdns.io",
    preferredMethod: "POST",
    enabled: false,
    notes:
      "Public NextDNS DoH endpoint. Disabled by default because browser-origin tests were CORS blocked; custom profiles can still be added."
  },
  {
    id: "mullvad",
    name: "Mullvad",
    endpoint: "https://dns.mullvad.net/dns-query",
    preferredMethod: "GET",
    enabled: false,
    notes:
      "Present for comparison, but disabled by default because browser-origin tests were CORS blocked."
  },
  {
    id: "control-d",
    name: "Control D",
    endpoint: "https://freedns.controld.com/p0",
    preferredMethod: "GET",
    enabled: true
  }
];

export const DEFAULT_HOSTNAMES = [
  "example.com",
  "wikipedia.org",
  "mozilla.org",
  "ietf.org",
  "github.com",
  "cloudflare.com",
  "google.com",
  "apple.com"
];
